import { useState, useEffect, useCallback } from "react";
import {
  Button,
  ButtonGroup,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import Select from "react-select";
import "react-perfect-scrollbar/dist/css/styles.css";
import { selectThemeColors } from "@utils";
import * as Constants from "../../../../constants";
import { getHearderAuth, CustomAvatar } from "@utils";
import axios from "axios";
import { useQuery } from "react-query";
import BreadCrumbs from "@components/breadcrumbs";
import { useHistory, Link, useLocation } from "react-router-dom";
import StorageUsageComponent from "../../../../views/apps/chat/StorageUsageComponent";
import EmployeeSelector from "../../../../views/apps/chat/EmployeeSelector";
import { countryOptions } from "../../../../views/apps/chat/countryOptions";
import { useTranslation } from "react-i18next";
import SliderWorkChat from "../../../../views/apps/ecommerce/components/SliderWorkChat";
import { useSelector } from "react-redux";
import { roleUser } from "../../../../views/apps/ecommerce/utils/utils";

const templateOptions = [
  { value: "", label: "--- Send a template ---" },
  { value: "0", label: "+ Create a template" },
];

const dataChatMessage = [
  {
    title: "As an agent, I want to view all conversations.",
    content:
      "Access and review past chat conversations to continue assisting customers effectively.",
    nameButton: "View All Conversations",
    link: "https://worksuite.cloodo.com/apps/message",
  },

  {
    title: "As a team member, I want to share chat history.",
    content:
      "Share chat histories with team members for better collaboration and customer support.",
    nameButton: "Share Chat History",
    link: "https://worksuite.cloodo.com/apps/message/whatsapp?action=share-chat-history",
  },
];

const ChatMenu = () => {
  const history = useHistory();
  const [formModal, setFormModal] = useState(false);
  const [firstNum, setFirstNum] = useState(countryOptions[0].value);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [template, setTemplate] = useState("");
  const [showError, setShowError] = useState("");
  const [currentUser, setCurrentUser] = useState(null);
  const { t } = useTranslation();
  const describe =
    "Easily access and manage the history of all your WhatsApp conversations. Share chat histories with team members or export them as needed.";

  const [isConnected, setIsConnected] = useState(false);
  const [isEmployeeListVisible, setIsEmployeeListVisible] = useState(true); // State for toggling EmployeeListSection visibility

  const selectedTemplate = templateOptions.find(
    (option) => option.value === template
  );
  const selectedFN = countryOptions.find((option) => option.value === firstNum);

  const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = useCallback((index) => {
    setActiveIndex(index);

    let channel = "";
    switch (index) {
      case 0: // All messages
        channel = "all_messages";
        break;
      case 1: // WhatsApp
        channel = "whatsapp";
        break;
      case 2: // Live Chat
        channel = "live_chat";
        break;
    }

    if (channel && channel !== "all_messages") {
      history.push(`/apps/message/${channel}`);
    } else {
      history.push("/apps/message");
    }
  }, []);

  useEffect(() => {
    const path = window.location.pathname;

    if (path.includes("whatsapp")) {
      setActiveIndex(1);
    } else if (path.includes("live_chat")) {
      setActiveIndex(2);
    } else {
      setActiveIndex(0);
    }
  }, [window.location.pathname]);

  const fetchTemplates = async () => {
    const headers = getHearderAuth();
    const response = await axios.get(
      `${Constants.CONVERT_CLOODO}list-template`,
      { headers }
    );
    return response.data;
  };

  const { data: templates, isLoading: isFetching } = useQuery(
    "templates",
    fetchTemplates
  );

  useEffect(() => {
    if (templates && templates.length > 0) {
      templates.forEach((element) => {
        const index = templateOptions.findIndex(
          (opt) => opt.value === element["id"]
        );
        if (element["status"] == 1 && index === -1) {
          templateOptions.push({
            value: element["id"],
            label: element["name"],
          });
        } else if (element["status"] == 0 && index !== -1) {
          templateOptions.splice(index, 1);
        } else if (element["status"] == 1 && index !== -1) {
          templateOptions[index]["label"] = element["name"];
        }
      });
      templateOptions.sort((a, b) => {
        if (a.value === "0") return 1;
        if (b.value === "0") return -1;
        return 0;
      });
    }

    const checkConnection = async (uuid) => {
      try {
        const response = await axios.get(
          `https://convert.cloodo.com/check-connect-waba?uuid=${uuid}&_=${Date.now()}`
        );
        if (response.data && response.data.connect) {
          setIsConnected(true);
        }
      } catch (error) {
        console.error("Error checking connection:", error);
      }
    };

    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        const uuid = userData.id;
        if (uuid) {
          checkConnection(uuid);
        } else {
          console.error("UUID not found");
        }
      } catch (error) {
        console.error("Error parsing userData from localStorage:", error);
      }
    }

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${Constants.CONVERT_CLOODO}user-share`,
      headers: getHearderAuth(false),
    };
    axios
      .request(config)
      .then((response) => {
        const data = response.data?.data;
        if (data) {
          localStorage.setItem("token_sh", data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [templates]);

  const handleCodeChange = (option) => {
    setFirstNum(option.value);
  };

  const handleTemplateChange = (option) => {
    if (option.value == 0 && option.value != "") {
      window.postMessage({ type: "callQuickReply" }, "*");
      setFormModal(!formModal);
    } else if (option.value > 0) {
      setTemplate(option.value);
    }
  };

  const turnConnect = () => {
    setIsConnected(true);
  };

  const chatNow = () => {
    if (phoneNumber.length > 6 && phoneNumber.length < 13) {
      if (template > 0) {
        setShowError("");
        if (templates && templates.length > 0) {
          templates.forEach((element) => {
            const index = templateOptions.findIndex(
              (opt) => opt.value === element["id"] && template === element["id"]
            );
            if (index !== -1) {
              const myObject = {
                phone: `${firstNum}${phoneNumber}`,
                mess: "",
                file: "",
              };
              if (element["type"] == 1) {
                myObject["mess"] = element["message"];
              } else if (element["type"] == 2) {
                myObject["file"] = element["file"];
              }
              setFirstNum(countryOptions[0].value);
              setPhoneNumber("");
              setTemplate("");
              sessionStorage.setItem("datacn", JSON.stringify(myObject));
            }
          });
        }
      } else {
        setShowError("template");
      }
    } else {
      setShowError("phone");
    }
  };

  const [employees, setEmployees] = useState([]);
  const [employeeGroups, setEmployeeGroups] = useState({});

  const fetchEmployeeData = async () => {
    try {
      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${Constants.REST_API_WORKSUITE_V3}widgets/detail`,
        headers: getHearderAuth(),
        data: {},
      };

      const response = await axios.request(config);
      if (response && response.data && response.data.list_agent) {
        const uniqueEmployees = Array.from(
          new Set(response.data.list_agent.map((employee) => employee.id))
        ).map((id) => {
          return response.data.list_agent.find(
            (employee) => employee.id === id
          );
        });

        setEmployees(uniqueEmployees); // Set unique employees
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  let datac = useLocation();
  const dataClient = datac?.state?.clientDetail;

  useEffect(() => {
    fetchEmployeeData();
    if (dataClient) {
      setCurrentUser(dataClient);
    } else {
      const userDfString = localStorage.getItem("user_df");
      if (userDfString) {
        try {
          const userDf = JSON.parse(userDfString);
          setCurrentUser(userDf);
        } catch (error) {
          console.error("Error parsing user_df from localStorage:", error);
        }
      }
    }
  }, [dataClient]);

  const handleEmployeeClick = (employee) => {
    setCurrentUser(employee);
    history.push({
      pathname: `/apps/message`,
      state: { clientDetail: { ...employee, uid: employee.id } },
    });
  };

  const EmployeeListSection = () => (
    <div
      className="employee-list-section"
      style={{
        padding: "20px",
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <h4
        style={{ marginBottom: "20px", color: "#495057", cursor: "pointer" }}
        onClick={() => setIsEmployeeListVisible(!isEmployeeListVisible)}
      >
        Switch to view employee messages{" "}
        <span style={{ float: "right" }}>
          {isEmployeeListVisible ? "▲" : "▼"}
        </span>
      </h4>
      {isEmployeeListVisible && ( // Conditional rendering based on visibility state
        <>
          {currentUser?.fullName && (
            <div
              className="loading-status"
              style={{
                padding: "15px",
                margin: "0 0 20px 0",
                backgroundColor: "#fff",
                borderRadius: "6px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ fontSize: "14px", color: "#6e6b7b" }}>
                  {currentUser ? (
                    <>
                      Viewing messages from{" "}
                      <span style={{ fontWeight: 500 }}>
                        {currentUser.fullName} ({currentUser.email})
                      </span>
                    </>
                  ) : (
                    "Viewing default messages"
                  )}
                </span>
              </div>
              {currentUser && (
                <Link
                  to={{
                    pathname: `/apps/message`,
                    state: { clientDetail: {} },
                  }}
                  color="secondary"
                  size="sm"
                  style={{
                    padding: "5px 10px",
                    fontSize: "12px",
                  }}
                >
                  Reset to Default
                </Link>
              )}
            </div>
          )}
          <Row>
            {employees.map((employee) => (
              <Col key={employee.id} md="4" style={{ marginBottom: "10px" }}>
                <div
                  onClick={() => handleEmployeeClick(employee)}
                  className="employee-item"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                    marginBottom: "10px",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className="employee-avatar"
                    style={{ marginRight: "10px", position: "relative" }}
                  >
                    {employee.image ? (
                      <img
                        src={employee.image_url}
                        alt={employee.name}
                        style={{
                          borderRadius: "50%",
                          width: "40px",
                          height: "40px",
                        }}
                      />
                    ) : (
                      <CustomAvatar
                        color="light-primary"
                        name={employee.name}
                        size={"36px"}
                        fontSize={"13px"}
                        avatarUrl={employee.image}
                      />
                    )}
                    <span
                      className={`status-dot ${employee.status}`}
                      style={{
                        position: "absolute",
                        bottom: "0",
                        right: "0",
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        backgroundColor:
                          employee.status === "enabled" ? "#28a745" : "#dc3545",
                      }}
                    />
                  </div>
                  <div className="employee-info">
                    <span
                      className="employee-name"
                      style={{
                        display: "block",
                        fontWeight: "500",
                        color: "#495057",
                      }}
                    >
                      {employee.name}
                    </span>
                    <span
                      className="employee-email"
                      style={{
                        display: "block",
                        fontSize: "0.875rem",
                        color: "#6c757d",
                      }}
                    >
                      {employee.email}
                    </span>
                    <span
                      className="employee-role"
                      style={{
                        display: "block",
                        fontSize: "0.875rem",
                        color: "#6c757d",
                      }}
                    >
                      {employee.role === "manager" ? (
                        <i className="fas fa-user-tie"></i>
                      ) : (
                        <i className="fas fa-user"></i>
                      )}
                    </span>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </>
      )}
    </div>
  );

  const isLoadingChatContact = useSelector(
    (state) => state.chat.isLoadingChatContact
  );

  return (
    <>
      <div className="header-wc">
        <BreadCrumbs
          breadCrumbTitle={t("Chat Messages")}
          breadCrumbParent={t("Workchat")}
          breadCrumbActive={t("Messages")}
          className="brc-chat"
        />
        <div className="mt-1" style={{ marginBottom: "-30px" }}>
          <SliderWorkChat data={dataChatMessage} describe={describe} />
        </div>

        {/* New Employee List Section */}
        {roleUser() !== "client" ? <EmployeeListSection /> : ""}

        {/* Loading Indicator */}
        {isLoadingChatContact && (
          <div
            className="loading-indicator"
            style={{ textAlign: "center", margin: "20px 0" }}
          >
            <Spinner color="primary" />
            <p>Loading contacts...</p>
          </div>
        )}

        <div className="wa-top-nav">
          <div className="nav-left-area">
            <ul className="group-list">
              <li
                className={activeIndex === 0 ? "active" : ""}
                onClick={() => handleClick(0)}
              >
                All messages
              </li>
              <li
                className={activeIndex === 1 ? "active" : ""}
                onClick={() => handleClick(1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 256 258"
                  style={{ marginRight: "5px" }}
                >
                  <rect width="256" height="258" fill="none" />
                  <defs>
                    <linearGradient
                      id="logosWhatsappIcon0"
                      x1="50%"
                      x2="50%"
                      y1="100%"
                      y2="0%"
                    >
                      <stop offset="0%" stop-color="#1faf38" />
                      <stop offset="100%" stop-color="#60d669" />
                    </linearGradient>
                    <linearGradient
                      id="logosWhatsappIcon1"
                      x1="50%"
                      x2="50%"
                      y1="100%"
                      y2="0%"
                    >
                      <stop offset="0%" stop-color="#f9f9f9" />
                      <stop offset="100%" stop-color="#fff" />
                    </linearGradient>
                  </defs>
                  <path
                    fill="url(#logosWhatsappIcon0)"
                    d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a122.994 122.994 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004"
                  />
                  <path
                    fill="url(#logosWhatsappIcon1)"
                    d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z"
                  />
                  <path
                    fill="#fff"
                    d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561c0 15.67 11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716c-3.186-1.593-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64"
                  />
                </svg>
                WhatsApp
              </li>
              <li
                className={activeIndex === 2 ? "active" : ""}
                onClick={() => handleClick(2)}
              >
                Live Chat
              </li>
            </ul>
          </div>
          <div className="nav-right-area">
            <ButtonGroup className="mb-1 menu-ext-chat">
              {/* <Button.Ripple outline color='primary' size='sm' id='el-tooltip-me-connect' onClick={() => history.push('/apps/settings/messenger-connect')}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" /><path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.958 9.958 0 0 1-4.863-1.26l-.305-.178l-3.032.892a1.01 1.01 0 0 1-1.28-1.145l.026-.109l.892-3.032A9.958 9.958 0 0 1 2 12C2 6.477 6.477 2 12 2M9.793 9.793l-3 3a1 1 0 1 0 1.414 1.414l2.293-2.293l2.293 2.293a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13.5 12.086l-2.293-2.293a1 1 0 0 0-1.414 0" /></g></svg>
                            </Button.Ripple>
                            <UncontrolledTooltip placement='top' target='el-tooltip-me-connect'>
                                {t('Messenger Connect')}
                            </UncontrolledTooltip> */}

              {activeIndex === 1 && (
                <>
                  <Button.Ripple
                    className={!isConnected ? "icon-with-badge" : ""}
                    outline
                    color={isConnected ? "primary" : "danger"}
                    size="sm"
                    id="el-tooltip-wa-connect"
                    onClick={() =>
                      history.push("/apps/settings/whatsapp-connect")
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 15 15"
                    >
                      <path
                        fill="currentColor"
                        d="m1.9 11.7l.447.224l.138-.277L2.3 11.4zm1.4 1.4l.3-.4l-.247-.185l-.277.138zM.5 14.5l-.447-.224a.5.5 0 0 0 .67.671zm4-10l-.277-.416A.5.5 0 0 0 4 4.5zm6 6v.5a.5.5 0 0 0 .416-.223zM6.254 5.026l.493-.083zm.14.836l-.493.082zm-.432.997l.277.416zm4.68 3.428l.416.277zm-.668-1.541l.083-.493zm-.836-.14l-.082.493zm-.997.432l-.416-.277zM0 7.5c0 1.688.558 3.247 1.5 4.5l.8-.6A6.47 6.47 0 0 1 1 7.5zM7.5 0A7.5 7.5 0 0 0 0 7.5h1A6.5 6.5 0 0 1 7.5 1zM15 7.5A7.5 7.5 0 0 0 7.5 0v1A6.5 6.5 0 0 1 14 7.5zM7.5 15A7.5 7.5 0 0 0 15 7.5h-1A6.5 6.5 0 0 1 7.5 14zM3 13.5A7.47 7.47 0 0 0 7.5 15v-1a6.469 6.469 0 0 1-3.9-1.3zM.723 14.947l2.8-1.4l-.448-.894l-2.8 1.4zm.729-3.47l-1.4 2.8l.894.447l1.4-2.8zM4 4.5v1h1v-1zM9.5 11h1v-1h-1zM4 5.5A5.5 5.5 0 0 0 9.5 11v-1A4.5 4.5 0 0 1 5 5.5zm.777-.584l.214-.142l-.555-.832l-.213.142zm.984.192l.14.836l.986-.164l-.14-.837zm-.076 1.335l-.962.641l.554.832l.962-.641zm.216-.499a.5.5 0 0 1-.216.499l.554.832a1.5 1.5 0 0 0 .648-1.495zm-.91-1.17a.5.5 0 0 1 .77.334l.986-.165a1.5 1.5 0 0 0-2.311-1.001zm5.925 6.003l.142-.213l-.832-.555l-.142.214zm-.86-2.524l-.836-.14l-.164.987l.836.139zm-2.33.508l-.642.962l.832.554l.641-.962zm1.494-.648a1.5 1.5 0 0 0-1.495.648l.832.554a.5.5 0 0 1 .499-.216zm1.838 2.451a1.5 1.5 0 0 0-1.001-2.311l-.165.986a.5.5 0 0 1 .334.77z"
                      />
                    </svg>
                  </Button.Ripple>
                  <UncontrolledTooltip
                    placement="top"
                    target="el-tooltip-wa-connect"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {isConnected
                      ? "Connected to WhatsApp"
                      : `WhatsApp Not Integrated
                      It seems you haven't connected your WhatsApp account yet.
                      💡 Get started by integrating now:
Click the icon to go to the Setup Wizard and scan the QR code for seamless integration.`}
                  </UncontrolledTooltip>

                  <Button.Ripple
                    outline
                    color="primary"
                    size="sm"
                    id="el-tooltip-scwnc"
                    onClick={() => setFormModal(!formModal)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g fill="none" fill-rule="evenodd">
                        <path d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z" />
                        <path
                          fill="currentColor"
                          d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2.546 20.2A1.01 1.01 0 0 0 3.8 21.454l3.032-.892A9.957 9.957 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2ZM9.738 14.263c2.023 2.022 3.954 2.289 4.636 2.314c1.037.038 2.047-.754 2.44-1.673a.696.696 0 0 0-.088-.703c-.548-.7-1.289-1.203-2.013-1.703a.711.711 0 0 0-.973.158l-.6.915a.229.229 0 0 1-.305.076c-.407-.233-1-.629-1.426-1.055c-.426-.426-.798-.992-1.007-1.373a.227.227 0 0 1 .067-.291l.924-.686a.712.712 0 0 0 .12-.94c-.448-.656-.97-1.49-1.727-2.043a.695.695 0 0 0-.684-.075c-.92.394-1.716 1.404-1.678 2.443c.025.682.292 2.613 2.314 4.636Z"
                        />
                      </g>
                    </svg>
                  </Button.Ripple>
                  <UncontrolledTooltip
                    placement="top"
                    target="el-tooltip-scwnc"
                  >
                    Start chatting with non contact WhatsApp
                  </UncontrolledTooltip>
                  <Modal
                    isOpen={formModal}
                    toggle={() => setFormModal(!formModal)}
                    className="modal-dialog-centered modal-dialog-chat"
                  >
                    <ModalHeader toggle={() => setFormModal(!formModal)}>
                      Start a WhatsApp
                    </ModalHeader>
                    <ModalBody>
                      <p>
                        Initiate a conversion with a contact not on your list.
                      </p>
                      <Row>
                        <Col className="mb-1" md="6" sm="12">
                          <Select
                            theme={selectThemeColors}
                            className="react-select"
                            classNamePrefix="select"
                            value={selectedFN}
                            options={countryOptions}
                            isClearable={false}
                            onChange={handleCodeChange}
                          />
                        </Col>
                        <Col className="mb-1" md="6" sm="12">
                          <Input
                            type="number"
                            placeholder="Phone number"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            invalid={showError == "phone"}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col className="mb-1" md="6" sm="12">
                          <Select
                            className={`react-select ${showError == "template"
                                ? "react-select-invalid"
                                : ""
                              }`}
                            theme={selectThemeColors}
                            classNamePrefix="select"
                            value={selectedTemplate}
                            options={templateOptions}
                            isClearable={false}
                            onChange={handleTemplateChange}
                          />
                        </Col>
                      </Row>
                    </ModalBody>
                    <ModalFooter>
                      <Spinner
                        className="float-end mb-2"
                        style={{
                          position: "relative",
                          right: "15px",
                          top: "8px",
                          display: "none",
                        }}
                      />
                      <Button
                        color="primary"
                        className="btn-chat-now"
                        onClick={chatNow}
                      >
                        Chat Now
                      </Button>{" "}
                    </ModalFooter>
                  </Modal>
                  {isConnected && <EmployeeSelector />}
                  <Button.Ripple
                    outline
                    color="primary"
                    size="sm"
                    id="el-tooltip-qr"
                    onClick={() =>
                      window.postMessage({ type: "callQuickReply" }, "*")
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M18.923 20.77V17h-1.23v-4.615h2.788l-1.123 3.23h1.757l-2.192 5.154ZM3 20.076V4.615q0-.69.463-1.152Q3.925 3 4.615 3h14.77q.69 0 1.152.463q.463.462.463 1.152v5h-6.077V17H6.077L3 20.077Z"
                      />
                    </svg>
                  </Button.Ripple>
                  <UncontrolledTooltip placement="top" target="el-tooltip-qr">
                    Quick Reply
                  </UncontrolledTooltip>
                </>
              )}
              <StorageUsageComponent />
            </ButtonGroup>
          </div>
        </div>
      </div>
      <Button id="turn-tcn" onClick={turnConnect}></Button>
    </>
  );
};

export default ChatMenu;
